import { useEffect } from 'react';
import { onlineManager } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import { queryKeys } from './queryKeys';

function isBrowserOnline(): boolean {
  if (typeof navigator === 'undefined') {
    return true;
  }

  return navigator.onLine;
}

export function QueryConnectivityManager() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    onlineManager.setOnline(isBrowserOnline());

    const handleOnline = () => {
      onlineManager.setOnline(true);

      // Refresh critical query domains after reconnect so stale screens self-heal.
      void Promise.allSettled([
        queryClient.invalidateQueries({ queryKey: queryKeys.conversations.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.userSettings.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.permissionRequests.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.dashboard.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.admin.models.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.admin.agents.all }),
        queryClient.invalidateQueries({ queryKey: queryKeys.admin.features.all }),
      ]);
    };

    const handleOffline = () => {
      onlineManager.setOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return null;
}
